import { styled, TextField, Typography } from "@mui/material";

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: "24px",
    background: "#FFF",
    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
    height: "48px",
    padding: `0 ${theme.spacing(1)}`,
  },
}));

export const StyledLabel = styled(Typography)(({ theme }) => ({
  color: "#000",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "23px" /* 143.75% */,
  letterSpacing: "0.15px",
  marginLeft: "23px",
  marginBottom: "4px",
}));
